<template>
  <div class="office-panel">
    <ul class="position-list">
      <li v-for="(item, index) in sortedOfficeList" :key="getOfficeKey(item, index)" class="position-item">
        <span class="office-name">
          <span v-if="item.tier" class="tier-badge">{{ getTierLabel(item.tier) }}</span>
          {{ item.name }}
        </span>
        <span class="office-title">{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: {
    officeList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
    };
  },
  computed: {
    sortedOfficeList() {
      return this.officeList
        .map(item => this.normalizeOfficeItem(item))
        .filter(item => item.name || item.title)
        .sort((a, b) => this.getTierRank(a.tier) - this.getTierRank(b.tier));
    }
  },
  mounted() {
  },
  methods: {
    back() {
      this.$emit('officeStatusFn', false);
    },
    normalizeOfficeItem(item) {
      item = item || {};
      const isJournal = item.type === 'journals';
      const branch = item.branch && item.branch !== 'NULL' ? item.branch : '';
      const name = isJournal
        ? item.journal_name
        : `${item.association_name || ''}${branch}`;

      return {
        ...item,
        tier: isJournal ? item.journal_tier : item.association_tier,
        name,
        title: isJournal ? item.journal_title : item.association_title
      };
    },
    getTierRank(tier) {
      const sortOrder = ['国际级', '国家级', '省级', '市级', '其他'];
      const index = sortOrder.indexOf(tier);
      return index === -1 ? sortOrder.length : index;
    },
    getTierLabel(tier) {
      const keyMap = {
        '国际级': 'office_tier_international',
        '国家级': 'office_tier_national',
        '省级': 'office_tier_provincial',
        '市级': 'office_tier_municipal',
        '其他': 'other'
      };
      return tier ? this.$t(keyMap[tier] || 'other') : '-';
    },
    getOfficeKey(item, index) {
      return `${item.type || 'office'}-${item.name || 'unknown'}-${item.title || index}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.swipe-wrapper {
  $height: 44px;
  $scroll-height: calc(100% - 44px);
  overflow-y: auto;
  .header {
    position: relative;
    height: $height;
    line-height: $height;
    text-align: center;
    background-color: #edf0f4;
    box-shadow: 0 1px 6px #ccc;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    z-index: 5;
    .h-title {
      font-size: 14px;
    }
  }
  .scroll-container {
    height: $scroll-height;
  }
}
.office-panel {
  padding: 10px 14px 16px;
  background: #fff;
}

.position-list {
  padding: 0;
  margin: 0;

  li {
    list-style: none;
  }

  .position-item {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(78px, 26%);
    column-gap: 10px;
    align-items: start;
    padding: 10px 0;
    background: #fff;
    font-size: 13px;
    color: #666;
    border-radius: 0;
    text-align: left;
    line-height: 1.35;
  }

  .tier-badge {
    display: inline-block;
    margin-right: 6px;
    padding: 1px 4px;
    border-radius: 4px;
    background: #f3f3f3;
    color: #777;
    font-size: 11px;
    line-height: 16px;
    text-align: center;
    vertical-align: 1px;
  }

  .office-name {
    min-width: 0;
    color: #666;
    word-break: break-word;
  }

  .office-title {
    justify-self: end;
    color: #999;
    text-align: right;
    word-break: break-word;
  }
}
</style>
